import { SxProps, Theme } from "@mui/material/styles";
import theme, { gris2 } from "../../theme";

const styles: SxProps<Theme> = [
  {
    "&.container": {
      marginTop: "58px",
    },
    "& .formRechercherAdb": {
      padding: "34px",
      width: "100%",
      margin: 0,
    },
    "& .bouton": {
      "& button": {
        float: "right",
      },
    },
    "& .ligne": {
      "& > div": {
        marginTop: 3,
      },
    },
    "& .paragraph": {
      margin: "4px",
    },
    "& .titreSecondaire": {
      marginRight: "24px",
    },
    "& .tableauProfils": {
      background: "white",
      height: 40,
      "& > td": {
        fontSize: 13,
        color: theme.palette.common.black,
        borderBottom: "none",
        borderWidth: "1px",
        borderLeft: "none",
        "&:last-child": {
          borderRight: "none",
        },
        padding: "4px 8px",
      },
    },
    "& .tableauProfilsHeader": {
      height: 40,
      "& > th": {
        fontSize: 10,
        padding: "4px 8px",
        lineHeight: "1rem",
        fontWeight: "500",
        borderLeft: "none",
        "&:last-child": {
          borderRight: "none",
        },
      },
    },
    "& .link": {
      display: "flex",
      alignItems: "center",
    },
    "& .containerButton": {
      marginTop: 3,
      marginBottom: 3,
    },
    "& .icon": {
      color: gris2,
      marginRight: 1,
    },
  },
];

export default styles;
